<div class="spacer" />

<style>
	.spacer {
		flex: 1 1 0;
	}
</style>
